var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkWithAiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2C6.97701 2 2.50001 6.477 2.50001 12C2.49649 14.3636 3.33331 16.6515 4.86101 18.455L3.64301 20.485C3.55186 20.6367 3.50261 20.8099 3.50029 20.9869C3.49797 21.1639 3.54266 21.3383 3.62981 21.4924C3.71696 21.6464 3.84343 21.7746 3.99631 21.8638C4.1492 21.953 4.32301 22 4.50001 22H12.5C12.8679 21.6667 13.3828 20.8 12.5 20H6.26601L6.96001 18.844C7.07403 18.6536 7.12147 18.4307 7.09485 18.2103C7.06824 17.99 6.96909 17.7848 6.81301 17.627C5.70259 16.5048 4.94901 15.0792 4.64716 13.5296C4.34531 11.98 4.50868 10.3758 5.1167 8.91888C5.72472 7.46197 6.75021 6.21751 8.06404 5.34221C9.37787 4.46692 10.9213 3.99991 12.5 4C14.6217 4 16.6566 4.84285 18.1569 6.34315C19.6572 7.84344 20.5 9.87827 20.5 12C20.8679 12.3333 21.7828 12.8 22.5 12C22.5 6.477 18.023 2 12.5 2Z",
    fill: "url(#paint0_linear_4047_29258)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4047_29258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.408 20.373L23.3768 20.9271C23.1289 20.9947 23.005 21.0285 22.9036 21.0957C22.8138 21.1551 22.7372 21.2332 22.6787 21.325C22.6126 21.4286 22.5788 21.5555 22.5114 21.8093L21.9585 23.8891L21.4185 21.8059C21.3526 21.5516 21.3197 21.4245 21.2542 21.3205C21.1963 21.2284 21.1202 21.1499 21.0307 21.0899C20.9298 21.0221 20.806 20.9875 20.5586 20.9183L18.5309 20.3515L20.5621 19.7974C20.8099 19.7298 20.9339 19.696 21.0353 19.6288C21.1251 19.5693 21.2017 19.4913 21.2602 19.3996C21.3263 19.2959 21.3601 19.169 21.4275 18.9152L21.9804 16.8354L22.5204 18.9186C22.5862 19.1729 22.6192 19.3 22.6847 19.404C22.7426 19.4961 22.8187 19.5746 22.9081 19.6346C23.0091 19.7024 23.1329 19.737 23.3803 19.8062L25.408 20.373Z",
    fill: "url(#paint1_linear_4047_29258)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4047_29258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2293 21.1811L16.1723 21.4377C16.0434 21.469 15.9789 21.4846 15.9261 21.5157C15.8794 21.5433 15.8396 21.5795 15.8091 21.622C15.7747 21.67 15.7572 21.7288 15.7221 21.8465L15.4348 22.8107L15.1534 21.8447C15.1191 21.7269 15.1019 21.6679 15.0678 21.6197C15.0376 21.577 14.998 21.5405 14.9515 21.5127C14.8989 21.4813 14.8345 21.4652 14.7057 21.4331L13.6504 21.1699L14.7074 20.9134C14.8363 20.8821 14.9008 20.8664 14.9536 20.8353C15.0003 20.8077 15.0402 20.7716 15.0706 20.7291C15.105 20.681 15.1225 20.6222 15.1576 20.5045L15.4449 19.5403L15.7263 20.5063C15.7606 20.6242 15.7778 20.6831 15.8119 20.7314C15.8421 20.7741 15.8817 20.8105 15.9282 20.8383C15.9808 20.8698 16.0452 20.8858 16.174 20.918L17.2293 21.1811Z",
    fill: "url(#paint2_linear_4047_29258)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4047_29258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.368 15.9967L18.8758 16.3513C18.6938 16.3946 18.6027 16.4162 18.5282 16.4592C18.4623 16.4973 18.406 16.5473 18.3631 16.6061C18.3145 16.6725 18.2898 16.7538 18.2403 16.9164L17.8347 18.2493L17.4374 16.9139C17.3889 16.751 17.3646 16.6695 17.3165 16.6028C17.2739 16.5438 17.218 16.4934 17.1523 16.4549C17.078 16.4115 16.9871 16.3893 16.8053 16.3449L15.3154 15.981L16.8076 15.6264C16.9896 15.5832 17.0807 15.5615 17.1552 15.5185C17.2211 15.4804 17.2774 15.4304 17.3203 15.3717C17.3689 15.3053 17.3937 15.224 17.4431 15.0613L17.8487 13.7285L18.246 15.0638C18.2945 15.2268 18.3188 15.3082 18.3669 15.3749C18.4095 15.4339 18.4654 15.4843 18.5311 15.5228C18.6054 15.5663 18.6963 15.5885 18.8781 15.6329L20.368 15.9967Z",
    fill: "url(#paint3_linear_4047_29258)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4047_29258",
    x1: 2.5,
    y1: 12,
    x2: 22.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4047_29258",
    x1: 21.9804,
    y1: 16.8354,
    x2: 21.9585,
    y2: 23.8891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4047_29258",
    x1: 15.4449,
    y1: 19.5403,
    x2: 15.4348,
    y2: 22.8107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4047_29258",
    x1: 17.8487,
    y1: 13.7285,
    x2: 17.8347,
    y2: 18.2493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10A37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4047_29258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2771,
    height: 14.7037,
    fill: "white",
    transform: "translate(26.6602 11.9094) rotate(90.1784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4047_29258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.36054,
    height: 4.77184,
    fill: "white",
    transform: "translate(17.833 19.0027) rotate(90.1784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4047_29258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.0278,
    height: 6.73672,
    fill: "white",
    transform: "translate(21.2197 12.9855) rotate(90.1784)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkWithAiIcon);
export default __webpack_public_path__ + "static/media/talkWithAIIcon.fb0672c578985bfb51237370e1fe31fc.svg";
export { ForwardRef as ReactComponent };